/* unplugin-vue-components disabled */import { render } from "./zhejiang.vue?vue&type=template&id=460c9f7e&scoped=true"
import script from "./zhejiang.vue?vue&type=script&lang=js"
export * from "./zhejiang.vue?vue&type=script&lang=js"

import "./zhejiang.vue?vue&type=style&index=0&id=460c9f7e&lang=scss&scoped=true"
import "./zhejiang.vue?vue&type=style&index=1&id=460c9f7e&lang=scss"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-460c9f7e"]])

export default __exports__